<template>
	<div class="mailing-lists-picker">
		<mailing-list-subscribe v-bind:key="data.id" v-for="(data) in mailingLists" v-bind:mailingList="data" v-bind:dachSelection="dachSelection">
		</mailing-list-subscribe>
	</div>
</template>

<script>
import MailingListSubscribe from 'PublicJs/MailingLists/components/MailingListSubscribe';
import api from 'PublicJs/MailingLists/components/api';

export default {
	name: 'MailingLists',
	components: {
		MailingListSubscribe
	},
	props: {
		selection: {
			type: String,
			required: false,
			default: ''
		},
		editMode: {
			type: String,
			required: false,
			default: 'false'
		},
		preview: {
			type: String,
			required: false,
			default: 'true'
		}
	},
	mounted: function () {
		api.getMailingLists().then((data) => {
			data.forEach((list) => {
				list.selected = this.selectedLists.includes(list.id.toString());
			});
			// DON'T se it before the loop or reactivity is broken!
			this.mailingLists = data;
		});

		if (this.editMode == 'true') {
			api.getNewsletterRecipient().then((data) => {
				this.dachSelection = data.newsletterRecipient.dach_selection;
			});
		}
	},
	computed: {
		selectedLists: function () {
			return this.selection.split(',');
		}
	},
	data: function () {
		return {
			mailingLists: [],
			dachSelection: '',
		}
	}
}
</script>
